import React from 'react';
import { useSelector } from 'react-redux';
import { TranslationInfo } from 'redux/schemas/models/edit-translations';
import { getLectureComponent } from 'redux/selectors/timeline';
import { ComponentType, NLectureComponent } from 'redux/schemas/models/lecture-component';
import EditableQuizBase from './quiz-base/editable-quiz-base';


type EditableProps = {
  editInfo: TranslationInfo,
  containerClass: string,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableQuiz = ({
  editInfo,
  containerClass,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const lectureComponent = useSelector((state) => (
    getLectureComponent(state, editInfo.id)
  )) as NLectureComponent<ComponentType.QUIZ>;
  const currentQuiz = useSelector((state) => state.models.quizzes[lectureComponent.quiz]);
  const currentQuestions = useSelector((state) => (
    currentQuiz.questions?.map((questionId) => {
      const { questionText, type, horizontalAxisLabel, verticalAxisLabel, numRows, numColumns, translationIds: qTranslationIds } = state.models.quizQuestions[questionId];
      const currentQuestion = {
        question: {
          id: questionId,
          questionText,
          type,
          horizontalAxisLabel,
          verticalAxisLabel,
          numRows,
          numColumns,
          translationIds: qTranslationIds,
        },
        options: state.models.quizQuestions[questionId].responseOptions?.map((optionId) => {
          const { optionContent, readOnly, explanation, secondaryExplanation, translationIds: oTranslationIds } = state.models.quizQuestionOptions[optionId];
          return {
            id: optionId,
            optionContent,
            readOnly,
            explanation,
            secondaryExplanation,
            translationIds: oTranslationIds,
          };
        }),
      };
      return currentQuestion;
    })
  ));
  return (
    <EditableQuizBase
      componentType={ComponentType.QUIZ}
      currentQuiz={currentQuiz}
      currentQuestions={currentQuestions}
      containerClass={containerClass}
      onSaveRef={onSaveRef}
      setSavingDisabled={setSavingDisabled}
      lectureComponent={lectureComponent}
      editInfo={editInfo}
    />
  );
};

export default EditableQuiz;
